import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/BrowserExtensionHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/KonamiCodeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/telemetry-initializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/root.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"assets/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./SF-Pro-Display-Medium.otf\",\"variable\":\"--font-sf\"}],\"variableName\":\"sfPro\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"assets/fonts/index.ts\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
